module.exports = "../dist/img/upper-banner-38.8193.jpg";